<template>
    <div class="DshUndeveloped">
        {{ propsObj._type }}类型暂未开发……
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshUndeveloped",
        mixins: [controlMixin],
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>

<style lang="less" scoped>
    .DshUndeveloped {
        width: 100%;
    }
</style>
<style lang="less">
    .DshUndeveloped {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshUndeveloped.vue